import "./ClientPraise.module.css";
import Header from "@/reusable_sections/Header";
import Testimonials from "./sections/Testimonials";
import Waitlist from "./sections/Waitlist";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import GamingSocialFooter from "@/reusable_sections/Footer";
export default function ClientPraisePage() {
  return <div>
      <Header />
      <Testimonials />
      <Waitlist />
      <FrequentlyAskedQuestions />
      <GamingSocialFooter />
    </div>;
}